import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiGet } from '../../../../api/queries/apiGet';
import { API_BASE_URL } from '../constants/consts';
import { universalMFAQueryKeys } from '../constants/queryKeys';
import type { ApiError, QueryFilters } from '../types';
import { buildUniversalMfaQueryParams } from '../constants/utils';

const END_POINT = '/metric/mfaTriggerRate';

const fetchMfaTriggerRate = async (filters: QueryFilters): Promise<number> => {
    const data = await apiGet<number>(`${API_BASE_URL}${END_POINT}`, buildUniversalMfaQueryParams(filters));
    return data;
};

export const useMfaTriggerRate = (filters: QueryFilters): UseQueryResult<number, ApiError> => {
    return useQuery({
        queryKey: universalMFAQueryKeys.mfaTriggerRate(filters),
        queryFn: () => fetchMfaTriggerRate(filters)
    });
};
